import {useQuery} from '@apollo/react-hooks';
import type {ApolloQueryResult} from 'apollo-client';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {makeUniqueIdForTextable} from 'shells/inbox/helpers';
import type {Textable} from 'shells/inbox/types';

import type {
    GetRelatedTextables as GetRelatedTextablesQuery,
    GetRelatedTextablesVariables as GetRelatedTextablesQueryVariables,
} from 'nutshell-graphql-types';

import GET_TEXTABLES from '../queries/get-related-textables.graphql';

export const useGetRelatedTextables = (
    entityId: string
): {
    textables: Textable[];
    error: string | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<ApolloQueryResult<GetRelatedTextablesQuery>>;
} => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetRelatedTextablesQuery, GetRelatedTextablesQueryVariables>(GET_TEXTABLES, {
        variables: {entityId},
        fetchPolicy: 'network-only',
    });

    const relatedTextables = data ? data.relatedTextables : [];

    // Show all phones for each related peep
    const allTextables = relatedTextables
        ? relatedTextables.reduce<Array<any>>((acc, current) => {
              current.phones.all.forEach((phone) => {
                  const phoneNumber = phone && phone.value && phone.value.id ? phone.value.id : '';

                  // more specific id includes both the peep id and the phone number
                  return acc.push({
                      ...current,
                      id: makeUniqueIdForTextable(current.id, phoneNumber),
                      phone,
                      entityId: current.id,
                  });
              });

              return acc;
          }, [])
        : [];

    return {
        textables: allTextables,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
